import { createSelector } from 'reselect';
import { configSelector } from 'selectors/common';

import { defaultVisibilitySettings } from '../../const';
import { IRootState } from '../../reducers';
import { IViewVisibilitySetting } from '../../types';
import { adminSettingsSelector } from './adminSettings';
import { filterVisibilitySectionsByConfig, getMappedLinkViewSettings } from './utils';

const linkVisibilitySettingsSelector = createSelector(
  [(state: IRootState) => state.linkVisibilitySettings, adminSettingsSelector, configSelector],
  (linkVisibilitySettings, adminSettings, config): IViewVisibilitySetting[] => {
    if (
      linkVisibilitySettings.loading ||
      adminSettings.loading ||
      !linkVisibilitySettings?.content?.display ||
      !adminSettings.content?.sections
    ) {
      return [];
    }

    const defaultSettings = filterVisibilitySectionsByConfig(defaultVisibilitySettings, config);
    const settings = getMappedLinkViewSettings(
      defaultSettings,
      linkVisibilitySettings.content.display,
      adminSettings.content.sections,
    );
    return settings;
  },
);

export default linkVisibilitySettingsSelector;
